import { useState, useMemo, useEffect } from 'react'
import { AudienceTableRowType } from '@/features/analytics/model/slices/audienceSlice'
import { useInviteLinksStore } from '../../model';

export const useSearch = (data: AudienceTableRowType[]) => {
    const { searchQueryAudience, setSearchQueryAudience } = useInviteLinksStore();

    const [searchQuery, setSearchQuery] = useState(searchQueryAudience);

    useEffect(() => {
        setSearchQuery(searchQueryAudience);
    }, [searchQueryAudience]);

    const handleSearchChange = (query: string) => {
        setSearchQuery(query);
        setSearchQueryAudience(query);
    };

    function prepareUsername(username: string | undefined) {
        if (!username) return ''
        return "@" + username;
    }

    const filteredData: AudienceTableRowType[] = useMemo(() => {
        if (!searchQuery) return data
        return data.filter((item) => {
            const inviteLinkNameMatch =
                (item.source ?? '').toLowerCase().includes(searchQuery.toLowerCase())
            const usernameMatch =
                (prepareUsername(item.username)).toLowerCase().includes(searchQuery.toLowerCase())
            const fullNameMatch =
                (item.name ?? '').toLowerCase().includes(searchQuery.toLowerCase())
            return (
                inviteLinkNameMatch ||
                usernameMatch ||
                fullNameMatch
            )
        })
    }, [data, searchQuery])

    return { searchQuery, setSearchQuery: handleSearchChange, filteredData };
}
